import * as React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { useDataGroupsReact } from 'common/contexts/react/data-group-context';
import { InputLabelReact } from 'common/components/input/label';
import { TagInputReact } from 'common/components/tag-input';
import { TagInputSearchMode } from 'common/components/tag-input/types';
import { DataGroup } from 'common/widgets/data-group-selector/types';
type EvalContextSelectProps = {
  selectedEvalContext?: string | null;
  onSelect: (evalContext: string) => void;
};
export function EvalContextSelect(props: EvalContextSelectProps) {
  var _props$selectedEvalCo, _props$selectedEvalCo2;
  const [dataGroups, setDataGroups] = React.useState<DataGroup[]>([]);
  const {
    t
  } = useTranslation();
  const dataGroupResource = useDataGroupsReact();
  useEffect(() => {
    const models = dataGroupResource.getAllValues();
    setDataGroups(models);
  }, [dataGroupResource]);
  const defaultGroup = {
    displayName: t("query-builder.dg-user"),
    propertyName: "distinct_id"
  };
  const deviceIdGroup = {
    displayName: t("feature-flags.page.context.device-id"),
    propertyName: "device_id"
  };
  const isFlagContextEmpty = ((_props$selectedEvalCo = props.selectedEvalContext) !== null && _props$selectedEvalCo !== void 0 ? _props$selectedEvalCo : "").trim() === "";
  return <div data-sentry-component="EvalContextSelect" data-sentry-source-file="index.tsx">
      <InputLabelReact fieldId='context' label={t("feature-flags.page.config.context")} helpText={t("feature-flags.page.context-help")} data-sentry-element="InputLabelReact" data-sentry-source-file="index.tsx" />
      <TagInputReact fieldId='context' errorMessage={isFlagContextEmpty ? t("feature-flags.page.edit.error.empty-flag-context") : undefined} validationStatus={isFlagContextEmpty ? "invalid" : undefined} menuSections={[{
      items: [defaultGroup, deviceIdGroup, ...dataGroups].filter(dg => !!dg.propertyName).map(dataGroup => {
        return {
          label: dataGroup.displayName,
          value: dataGroup.propertyName,
          isSelected: dataGroup.propertyName === props.selectedEvalContext
        };
      })
    }]} controlledMode value={(_props$selectedEvalCo2 = props.selectedEvalContext) !== null && _props$selectedEvalCo2 !== void 0 ? _props$selectedEvalCo2 : ""} searchMode={TagInputSearchMode.Combobox} icon={props.selectedEvalContext ? "checkmark" : "search"} placeholder={t("feature-flags.page.context.enter-values")} mpItemsMenuAttrs={{
      'empty-message': t("feature-flags.page.context.no-data-groups"),
      'empty-search-results-message': t("feature-flags.page.context.no-data-groups")
    }} onChange={(ev: TODO) => {
      setTimeout(() => {
        var _ev$detail$value;
        return props.onSelect(((_ev$detail$value = ev.detail.value) !== null && _ev$detail$value !== void 0 ? _ev$detail$value : "").trim());
      });
    }} onClickMenuItem={(ev: TODO) => {
      setTimeout(() => props.onSelect(ev.detail.value));
    }} data-sentry-element="TagInputReact" data-sentry-source-file="index.tsx" />
    </div>;
}